import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { all_routes } from "../../router/all_routes";
import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import { Modal, Button } from "react-bootstrap";
import { OverlayTrigger } from "react-bootstrap";
import Loader from "../../../core/common/selfLoder";
import { Tooltip } from "antd";
import("../../../style/icon/themify/themify.css");

interface galleryData {
  album_id: number;
  album_name: string;
  cover_photo_url: string | boolean;
  created_at: string;
}
interface gallerMainRsponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: galleryData[];
}

const Gallery = () => {
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [delayedLoading, setDelayedLoading] = useState(true);

  // Notice Interfaces
  interface NoticeData {
    ID: number;
    heading: string;
    created_date: string;
  }
  interface Notice {
    success: boolean;
    message: string;
    statusCode: number;
    data: NoticeData[];
  }

  const {
    data: noticeResponse,
    loading: noticeLoading,
    error: noticeError,
  } = useApi<Notice>("/api/new/notices", {
    method: "GET",
    autoCall: true,
  });

  // Announcement Interfaces
  interface AnnouncementData {
    ID: number;
    announcement: string;
    created_date: string;
  }
  interface Announcement {
    success: boolean;
    message: string;
    statusCode: number;
    data: AnnouncementData[];
  }

  const {
    data: announcementResponse,
    loading: announcementLoading,
    error: announcementError,
  } = useApi<Announcement>("/api/announcement", {
    method: "GET",
    autoCall: true,
  });

  const { data: galleryResponse, loading: typeLoading } =
    useApi<gallerMainRsponse>("/api/gallery", {
      method: "GET",
      autoCall: true,
    });

  const getTimeAgo = (createdDate: string): string => {
    const created = new Date(createdDate);
    const now = new Date();

    const diffInMs = now.getTime() - created.getTime();
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

    if (diffInHours < 1) return "Just now";
    if (diffInHours < 24) {
      return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    }

    const diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays < 365) {
      return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    }

    const years = Math.floor(diffInDays / 365);
    return `${years} year${years > 1 ? "s" : ""} ago`;
  };


useEffect(() => {
  let timer : any;

  if (typeLoading) {
    setDelayedLoading(true);
  } else {
    timer = setTimeout(() => setDelayedLoading(false), 800);
  }

  return () => clearTimeout(timer);
}, [typeLoading]);



  return (
    <>
      <Loader loading={typeLoading} />

      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Gallery</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Communication & Culture</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Gallery
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex gap-2">
              {/* Announcement Open */}

              <div className="me-1 notification_item">
                <Link
                  to="#"
                  className="btn btn-menubar position-relative"
                  id="notification_popup"
                  data-bs-toggle="dropdown"
                  style={{
                    backgroundColor: "white",
                    padding: "19px",
                    border: "1px solid #e9edf4",
                  }}
                >
                  {/* <i className="ti ti-bell"></i> */}
                  {/* <i className="ti ti-brifcase-2" /> */}
                  <i className="ti-announcement" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                    <h4 className="notification-title">Announcement</h4>
                    <div className="d-flex p-0">
                      <Link to="#" className="btn btn-light w-100 me-2">
                        <i className="fa fa-times" title="Close" />
                      </Link>
                    </div>
                  </div>
                  <div className="noti-content px-3 py-2 bg-white rounded shadow-sm custom-noti">
                    <div className="d-flex flex-column">
                      {announcementResponse?.data?.map((item) => (
                        <div
                          key={item.ID}
                          className="d-flex align-items-start gap-3 border-bottom pb-3 mb-3 hover-noti"
                        >
                          {/* Content */}
                          <div className="flex-grow-1">
                            <Link
                              to="#"
                              className="text-decoration-none text-dark"
                            >
                              <p className="mb-1 ">{item.announcement}</p>
                            </Link>
                            <span className="text-muted small">
                              {getTimeAgo(item.created_date)}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex p-0">
                    {/* <Link to="#" className="btn btn-light w-100 me-2 mt-4">
                      Cancel
                    </Link> */}
                    <Link to="#" className="btn btn-primary w-100">
                      View All
                    </Link>
                  </div>
                </div>
              </div>

              {/* NOTICE BOARD */}
              <div className="me-1 notification_item">
                <Link
                  to="#"
                  className="btn btn-menubar position-relative "
                  id="notification_popup"
                  data-bs-toggle="dropdown"
                  style={{
                    backgroundColor: "white",
                    padding: "19px",
                    border: "1px solid #e9edf4",
                  }}
                >
                  {/* <i className="ti ti-bell"></i> */}
                  <i className="ti-blackboard" title="Notice Board" />
                </Link>
                <div className="dropdown-menu dropdown-menu-end notification-dropdown p-4">
                  <div className="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
                    <h4 className="notification-title">Notice Board</h4>
                    <div className="d-flex p-0">
                      <Link to="#" className="btn btn-light w-100 me-2">
                        <i className="fa fa-times" title="Close" />
                      </Link>
                    </div>
                  </div>
                  <div className="noti-content px-3 py-2 bg-white rounded shadow-sm">
                    <div className="d-flex flex-column">
                      {noticeResponse?.data?.map((item) => (
                        <div
                          key={item.ID}
                          className="d-flex align-items-start gap-3 border-bottom pb-3 mb-3 hover-noti"
                        >
                          <div className="flex-grow-1">
                            <Link
                              to="#"
                              className="text-decoration-none text-dark"
                            >
                              <p className="mb-1" style={{ fontSize: "15px" }}>
                                {item.heading}
                              </p>
                            </Link>
                            {/* <span className="text-muted small">10 hours ago</span> */}
                            <span className="text-muted small">
                              {getTimeAgo(item.created_date)}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="d-flex p-0 mt-4">
                    {/* <Link to="#" className="btn btn-light w-100 me-2">
                      Cancel
                    </Link> */}
                    <Link
                      to="/notice-circulars"
                      className="btn btn-primary w-100"
                    >
                      View All
                    </Link>
                  </div>
                </div>
              </div>

              <div className="head-icons ">
                <CollapseHeader />
              </div>
            </div>
          </div>

          {/* Gallery Content */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Gallery</h5>
            </div>
            <div className="card-body">
              {typeLoading ? (
                <div className="text-center">Loading...</div>
              ) : (
                <div className="row row-gap-4 ">
                  {galleryResponse?.data?.map((item, index) => (
                    <div className="col-lg-3 col-md-4  col-12" key={index}>
                      <div className="gallery-item-container">
                        <Link
                          to="/gallery-details"
                          state={{ album_id: item.album_id }}
                          className="gallery-item"
                        >
                          <img
                            src={
                              typeof item.cover_photo_url === "string"
                                ? item.cover_photo_url
                                : "/assets/img/placeholder.jpg"
                            }
                            alt={item.album_name}
                            className="img-fluid rounded w-100 fixed-height-img"
                          />

                          <div className="overlay">
                            <span className="album-name">
                              {item.album_name}
                            </span>
                          </div>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Lightbox */}
          {galleryResponse?.data && (
            <Lightbox
              open={openLightbox}
              close={() => setOpenLightbox(false)}
              slides={galleryResponse.data.map((item) => ({
                src:
                  typeof item.cover_photo_url === "string"
                    ? item.cover_photo_url
                    : "/assets/img/placeholder.jpg",
              }))}
              index={currentIndex}
            />
          )}
        </div>

        <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Gallery;

// VIKAS OLD

// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../../core/common/imageWithBasePath";
// import { all_routes } from "../../router/all_routes";
// import "yet-another-react-lightbox/styles.css";
// import Lightbox from "yet-another-react-lightbox";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import { OverlayTrigger } from "react-bootstrap";
// import { Tooltip } from "antd";
// import('../../../style/icon/themify/themify.css')

// interface galleryData {
//   album_id: number;
//   album_name: string;
//   cover_photo_url: string | boolean;
//   created_at: string;
// }
// interface gallerMainRsponse {
//   success: boolean;
//   message: string;
//   statusCode: number;
//   data: galleryData[];
// }

// const Gallery = () => {
//   const [openLightbox, setOpenLightbox] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const { data: galleryResponse, loading: typeLoading } =
//     useApi<gallerMainRsponse>("/api/gallery", {
//       method: "GET",
//       autoCall: true,
//     });

//   const handleImageClick = (index: number) => {
//     setCurrentIndex(index);
//     setOpenLightbox(true);
//   };

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Gallery</h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to={all_routes.adminDashboard}>
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Pages</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Gallery
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex gap-2">
//               <div className="head-icons ms-2">
//                 <Link to="#" title="Announcement">
//                   <i className="ti-announcement" data-bs-toggle="tooltip" title="Announcement" />
//                 </Link>
//               </div>
//               <div className="head-icons ms-2">
//                 <Link to="#">
//                   <i className="ti-blackboard" data-bs-toggle="tooltip" title="Notice Baord" />
//                 </Link>
//               </div>
//               <div className="head-icons ms-2">
//                 <CollapseHeader />
//               </div>
//             </div>
//           </div>

//           {/* Gallery Content */}
//           <div className="card">
//             <div className="card-body">
//               {typeLoading ? (
//                 <div className="text-center">Loading...</div>
//               ) : (
//                 <div className="row row-gap-4 justify-content-center">
//                   {galleryResponse?.data?.map((item, index) => (
//                     <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
//                       <div className="gallery-item-container">
//                         <Link
//                           to="/gallery-details"
//                           state={{ album_id: item.album_id }}
//                           className="gallery-item"
//                         >
//                           <img
//                             src={
//                               typeof item.cover_photo_url === "string"
//                                 ? item.cover_photo_url
//                                 : "/assets/img/placeholder.jpg"
//                             }
//                             alt={item.album_name}
//                             className="img-fluid rounded w-100"
//                           />
//                           <div className="overlay">
//                             <span className="album-name">
//                               {item.album_name}
//                             </span>
//                           </div>
//                         </Link>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Lightbox */}
//           {galleryResponse?.data && (
//             <Lightbox
//               open={openLightbox}
//               close={() => setOpenLightbox(false)}
//               slides={galleryResponse.data.map((item) => ({
//                 src:
//                   typeof item.cover_photo_url === "string"
//                     ? item.cover_photo_url
//                     : "/assets/img/placeholder.jpg",
//               }))}
//               index={currentIndex}
//             />
//           )}
//         </div>

//         <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//           <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Gallery;

// old
// import React from "react";
// import { Link } from "react-router-dom";
// import { all_routes } from "../../router/all_routes";
// import "yet-another-react-lightbox/styles.css";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";

// interface galleryData {
//   album_id: number;
//   album_name: string;
//   cover_photo_url: string | boolean;
//   created_at: string;
// }
// interface gallerMainRsponse {
//   success: boolean;
//   message: string;
//   statusCode: number;
//   data: galleryData[];
// }

// const Gallery = () => {
//   const { data: galleryResponse, loading: typeLoading } =
//     useApi<gallerMainRsponse>("/api/gallery", {
//       method: "GET",
//       autoCall: true,
//     });

//   const formatDate = (data: string) => {
//     const date = new Date(data);
//     return date.toLocaleDateString("en-GB");
//   };

//   return (
//     <>
//       {/* Page Wrapper */}
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Gallery</h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to={all_routes.employeeDashboard}>
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Content</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Gallery
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
//               <div className="ms-2 head-icons">
//                 <CollapseHeader />
//               </div>
//             </div>
//           </div>
//           {/* /Breadcrumb */}
//           <div className="card">
//             <div className="card-body p-3">
//               <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
//                 <h5>Gallery </h5>
//               </div>
//             </div>
//           </div>
//           <div className="row justify-content-center">
//             {galleryResponse?.data.map((item, index) => (
//               <div className="col-xxl-4 col-md-6" key={index}>
//                 <div key={index} className="card">
//                   <div className="card-body">
//                     <div className="img-sec w-100 position-relative mb-3">
//                       {/* <Link to={all_routes.blogCategories}> */}
//                       <Link to="/gallery-details" state={item.album_id}>
//                         <img
//                           src={
//                             typeof item.cover_photo_url === "string"
//                               ? item.cover_photo_url
//                               : undefined
//                           }
//                           className="img-fluid rounded w-100"
//                           alt="img"
//                           style={{ height: "250px" }}
//                         />
//                       </Link>
//                       <div className="">
//                         <span className="trend-tag badge bg-info-transparent fs-10 fw-medium">
//                           {item.album_name}
//                         </span>
//                       </div>
//                     </div>
//                     <div className="d-flex align-items-center justify-content-between mb-3">
//                       <div className="d-flex align-items-center">
//                         <span className="me-2 d-flex align-items-center">
//                           <i className="ti ti-calendar me-1" />{" "}
//                           {formatDate(item.created_at)}
//                         </span>
//                         <Link
//                           to="#"
//                           className="border-start link-default fs-14 fw-normal ps-2 me-2 text-truncate"
//                         >
//                           {item.album_name}
//                         </Link>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <div className="text-center mb-4">
//             <Link to="#" className="btn btn-white border">
//               <i className="ti ti-loader-3 text-primary me-2" />
//               Load More
//             </Link>
//           </div>
//         </div>
//         <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
//           <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Gallery;
